/** @forge-header
 * @id          parseHelpers
 * @role        Dual-read parsing for Kalshi fixed-point API migration | prefer new fields, fall back to legacy
 * @pattern     pure-fn
 * @purity      none
 * @units       cents (output from dollarsToCents) | integer (output from fpToInt)
 * @upstream    none
 * @downstream  kalshiApi/orders | kalshiApi/positions | kalshiApi/orderbook | market/marketStreamParsers
 * @exports     dollarsToCents:fn | fpToInt:fn
 * @test        parseHelpers.test.ts (19 cases)
 */

/** Parse a dollar string ("0.43") to cents integer (43). Falls back to legacy number. */
export function dollarsToCents(dollars: unknown, legacyCents: unknown): number | null {
  if (typeof dollars === 'string') {
    const n = Number(dollars);
    if (Number.isFinite(n)) return Math.round(n * 100);
  }
  if (typeof legacyCents === 'number' && Number.isFinite(legacyCents)) {
    return Math.round(legacyCents);
  }
  return null;
}

/** Parse a fixed-point string ("10.00") to integer (10). Falls back to legacy number. */
export function fpToInt(fp: unknown, legacyInt: unknown): number | null {
  if (typeof fp === 'string') {
    const n = Number(fp);
    if (Number.isFinite(n)) return Math.round(n);
  }
  if (typeof legacyInt === 'number' && Number.isFinite(legacyInt)) {
    return Math.round(legacyInt);
  }
  return null;
}
